export default "__VITE_ASSET__B50TcGSg__"